<template>
    <div class="input_group">
      <label :for="name">{{ label }}</label>
      <textarea
        :id="name"
        :name="name"
        :placeholder="placeholder"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @focusout="handleError"
        :disabled="disabled"
        :maxlength="maxlength"
        :class="{'input_field': true, 'input_error': errorMessage}">
        </textarea>

        <span v-if="errorMessage" class="error_message">{{ errorMessage }}</span>

    </div>
  </template>
  
  <script setup>
  import { defineProps, ref, watch } from 'vue'

  const props = defineProps({
    name: String,
    label: String,
    placeholder: String,
    modelValue: [String, Number],
    disabled: Boolean,
    error: String,
    maxlength: String,
  })

  const errorMessage = ref(props.error);

  watch(() => props.error, (value) => {
    if(value){
      errorMessage.value = value;
    }
  });

  const handleError = () => {
    errorMessage.value = null;
  };
  </script>
  
  <style scoped>
  .input_group {
    display: flex;
    flex-direction: column;
  }
  
  .input_group label {
    margin-bottom: 4px;
    font-weight: 500;
    text-align: left;
  }
  
  .input_field {
    padding: 10px;
    border: 1px solid #d7d7d7;
    border-radius: 4px !important;
    font-size: 15px;
    height: 400px;
  }

  .dark .input_field {
      background-color: #232932 !important;
      border-color: #394251 !important;
      color: #b5b9d0 !important;
  }

  .dark .input_field:focus {
    box-shadow: 0px 0px 0px 2px #655582;
  }
  
  .input_field:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  
  .input_field:disabled {
    background-color: #e9ecef;
    opacity: 1;
  }
  .input_error {
    border: 1px #df2b2b solid;
    box-shadow: 0px 0px 0px 3px rgb(255 136 136 / 30%);
  }
  .error_message {
    color: #df2b2b;
    font-weight: 500;
    margin-top: 4px;
  }
</style>
  